// Клиника и её точки работают по московскому времени, но `new Date().toISOString()` всегда даёт
// дату по UTC — с 21:00 до 23:59 UTC (00:00-02:59 МСК) это уже "вчера" по UTC, хотя в Москве уже
// наступили следующие сутки. Тот же сдвиг, что и todayInMoscow() на бэкенде (backend/routes/
// yclients.js) — Россия не переходит на летнее/зимнее время (с 2014), так что UTC+3 фиксированный,
// без библиотек часовых поясов. Date.now() — абсолютный момент времени, не зависит от таймзоны,
// выставленной на компьютере пользователя, поэтому корректен независимо от локальных настроек ОС.
export function mskTodayStr() {
  return new Date(Date.now() + 3 * 60 * 60 * 1000).toISOString().slice(0, 10);
}
